/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_NOTIFICATION_TYPE_CHANNEL_PREFERENCES = gql`
  query GetNotificationTypeChannelPreferences {
    notificationTypeChannelPreferences {
      notificationType
      channels
    }
  }
`
